// src/components/BookReview.jsx
import { Star } from "@mui/icons-material";
import { motion } from "framer-motion";
const reviews = [
    {
        name: "Pooja Sharma",
        text: "Truly impressed by their service! I was unsure at first but decided to give them a try — and I’m so glad I did. They were polite, arrived on time, and sorted everything without hassle. Highly recommended for anyone needing help at home."
    },
    {
        name: "Ashok Kumar",
        text: "Quick response and smooth process. I booked an appointment online, and the technician arrived the same day. He explained everything patiently and got the job done efficiently. Overall, a very satisfying experience.",
    },
    {
        name: "Rohit Bansal",
        text: "I had a really good experience with this team. The technician was professional, explained the issue clearly, and worked carefully to fix it. It’s rare to find such reliable home services these days.",
    },
    {
        name: "Rahul Sharma",
        text: "Very happy with the home visit! The service person was knowledgeable and friendly, handled the issue properly, and made sure everything worked before leaving. Will definitely call them again in the future.",
    },
    {
        name: "Neha Verma",
        text: "Fantastic service! I was worried it would take days, but they were fast and efficient. The whole process was smooth, from booking to completion. Definitely one of the best home service experiences I’ve had.",
    },
    {
        name: "Vikram Sethi",
        text: "Great experience from start to finish. Booking was easy, pricing was clear, and the technician was both skilled and polite. I appreciate the care they put into their work. I’ll be using their services again!",
    },

];

const BookReview = () => {
    return (
        <section
            id="reviews"
            className="min-h-screen bg-gray-950 text-white py-20 px-4"
        >
            <div className="max-w-6xl mx-auto text-center mb-16">
                <h2 className="text-3xl font-bold mb-4 text-yellow-400">
                    What Our Customers Say
                </h2>
                <p className="text-gray-300 max-w-xl mx-auto italic">
                    Customer satisfaction is what we look for, every time we provide you a
                    solution
                </p>
            </div>

            <motion.div
                className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: true }}
            >
                {reviews.map((review, index) => (
                    <motion.div
                        key={index}
                        className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl p-6 shadow-lg hover:shadow-yellow-500/20 transition-transform transform hover:scale-105"
                        whileHover={{ scale: 1.05 }}
                    >
                        <div className="flex items-center justify-between mb-3">
                            <h3 className="font-semibold text-yellow-400">{review.name}</h3>
                        </div>
                        <p className="text-sm text-gray-200 mb-4">"{review.text}"</p>
                        <div className="flex items-center justify-between">

                            <div className="flex gap-1 text-yellow-400">
                                {[...Array(5)].map((_, i) => (
                                    <Star key={i} fontSize="small" />
                                ))}
                            </div>
                        </div>
                    </motion.div>
                ))}
            </motion.div>
        </section>
    );
};

export default BookReview;
